export const LOAD_VIDEO_REPORT = "Reports/Video/LOAD_VIDEO_REPORT"
export const LOADING = "Reports/Video/LOADING"
export const PUT_VIDEO_REPORT = "Reports/Video/PUT_VIDEO_REPORT"
export const SORT_VIDEO_REPORT = "Reports/Video/SORT_VIDEO_REPORT"

export const loadVideoReport = date => ({
    type: LOAD_VIDEO_REPORT,
    payload: date
})
export const loading = mode => ({
    type: LOADING,
    payload: mode
})
export const putVideoReport = video_report => ({
    type: PUT_VIDEO_REPORT,
    payload: video_report
})
export const sortVideoReport = sortSource => ({
    type: SORT_VIDEO_REPORT,
    payload: sortSource
})